import { ChangeDetectorRef, Component, ErrorHandler, OnDestroy, OnInit, ChangeDetectionStrategy, signal } from '@angular/core'
import { Router } from '@angular/router'

import { KirjautunutKayttajaService } from '../_angular/service/kirjautunut-kayttaja.service'

import { VasenValikkoService } from 'app/_jaettu-angular/service/vasen-valikko.service'
import { LadataanService } from '../_jaettu-angular/service/ladataan.service'

import { Subject } from 'rxjs'

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginComponent implements OnInit, OnDestroy {
  readonly commonError = signal<string>(undefined)
  year: string = new Date().getFullYear() + ''

  private _ngUnsubscribe: Subject<void> = new Subject<void>()

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _ladataanService: LadataanService,
    private _vasenValikkoService: VasenValikkoService,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this._vasenValikkoService.paivitaAuki(false)
      this._changeDetectorRef.markForCheck()
    }, 5)
    this._kirjaudu()
  }

  private async _kirjaudu() {
    this.commonError.set(null)
    this._ladataanService.aloitaLataaminen()
    try {
      const kirjautuminenKunnossa = await this._kirjautunutKayttajaService.kirjautuminenKunnossa()
      if (kirjautuminenKunnossa) {
        this._ladataanService.lopetaLataaminen()
        this._router.navigate(['/'])
        return
      }

      this._kirjautunutKayttajaService.logoutImmediate()

      this._ladataanService.lopetaLataaminen()
      this._router.navigate(['/kirjauduttupois'])
    } catch (error) {
      this.commonError.set('Kirjautumisen aikana tapahtui virhe. Ilmoita tästä ylläpidolle.')
      this._errorHandler.handleError(error)
      this._ladataanService.lopetaLataaminen()
    }
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }
}
